import { organisationConstants } from '../../_constants/organisation.constants';
import { creditOrgService } from '../../_services/organisation/credits.service';

export const creditOrgActions = {
    getOrgCredit
};

function getOrgCredit(id, org) {
    return dispatch => {
        dispatch(request());
        creditOrgService.getOrgCreditList(id, org)
            .then(
                credits => {
                    dispatch(success(credits));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_CREDITS} }
    function success(orgCredits) { return { type: organisationConstants.RECEIVE_CREDITS, orgCredits } }
    function failure(error) { return { type: organisationConstants.CREDITS_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/orgcredits.action.js